import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(LanguageDe);

    /** @ngInject */
    function LanguageDe($translateProvider) {
        $translateProvider.translations('de',
            // TRANSLATIONS
        );
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/languages/de.ts